<nb-select (selectedChange)="changeLang($event)" *ngIf="translate.getLangs() && translate.getLangs().length > 1" [selected]="translate.getDefaultLang()"
           placeholder="{{ 'Choisir une langue' | translate}}" status="primary">
	<nb-option *ngFor="let lang of translate.getLangs()" [value]="lang">{{ 'lang.' + lang|translate }}</nb-option>
</nb-select>
